// const API_URL = "http://localhost:3020";
const API_URL = "https://server.lmeetup.com";

export default API_URL;
